import React from 'react';
import BasicWaveLoader from '@/common/components/loaders/BasicWaveLoader';

function MultipleComponentsLoader({ componentLoader: ComponentLoader = BasicWaveLoader, itemsCount, className = '' }) {
    return (
        <>
            {Array.from({ length: itemsCount }).map((v, index) => (
                <ComponentLoader key={index} className={className} />
            ))}
        </>
    );
}

export default MultipleComponentsLoader;
